import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { MainBoard } from "./MainBoard";
import { pathDesktop, pathMobile } from "../shared/Constants/Constants"

const myRoutes = () => {
  return (
    <Routes>
      <Route path={pathDesktop} element={<MainBoard/>} />
      <Route path={pathMobile} element={<MainBoard/>} />
    </Routes>
  );
}

export default myRoutes;